import { useEffect, useState } from 'react';
import { clearStoredSupabaseSession, supabase } from '../lib/supabase';
import { IS_DEMO, DEMO_USER } from '../lib/demoData';

export function useAuth() {
  const [user, setUser] = useState(IS_DEMO ? DEMO_USER : null);
  const [loading, setLoading] = useState(!IS_DEMO);

  useEffect(() => {
    if (IS_DEMO) return;

    supabase.auth.getSession()
      .then(({ data: { session } }) => {
        setUser(session?.user ?? null);
        setLoading(false);
      })
      .catch((error) => {
        if (/Invalid Refresh Token|Refresh Token Not Found/i.test(error?.message || '')) {
          clearStoredSupabaseSession();
        }
        setUser(null);
        setLoading(false);
      });

    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    if (IS_DEMO) {
      alert('Demo mode — sign out disabled. Connect Supabase to enable auth.');
      return;
    }
    await supabase.auth.signOut();
  };

  return { user, loading, signOut };
}
